import {
    MILITARY_VARIANT,
    STC_VARIANT,
    collection,
    isMilitaryEnabled,
    parentTypeFor,
} from "../_variants/index.js";
import {
    addSADD, editSADD, cancelSADD, linkSADD
} from "./actions";

function warning(item) {
    let warningMessage = "";
    if (item?.Signedoff === false) {
        warningMessage = warningMessage += `${item.Number} is not signedoff.<br>`;
    }
    return warningMessage === "" ? false : warningMessage;
}

const cellClassRules = {
    "text-orange font-bold": params => {
        return warning(params.data);
    }
}

const headers = [{
    "headerName": "Number",
    "field": "Number"
}, {
    "headerName": "POA/Arrangement",
    "field": "To"
}, {
    "headerName": "Date of Issue",
    "field": "Date.Issued",
    "type": "date"
}];

const ADDABLE_PARENT_TYPES = ["DesignChanges", "FlightConditions", "Repairs", "MilitaryDesignChanges", "MilitaryFlightConditions", "MilitaryRepairs"];
const EDITABLE_PARENT_TYPES = ["DesignChanges", "Repairs", "MilitaryDesignChanges", "MilitaryRepairs"];

/**
 * Build the attachable-table descriptor for the SADD register that matches
 * the supplied variant.
 *
 * @param {import("../_variants/index.js").Variant} variant
 */
export const makeSADDAttachable = (variant) => {
    const isMilitary = variant.key === "military";
    const labelSingular = isMilitary ? "Military SADD" : "SADD";
    const labelPlural = isMilitary ? "Military SADDs" : "SADDs";
    const saddParentType = parentTypeFor(variant, "SADDs");
    const saddCollection = collection(variant, "SADDs");

    const actions = [{
        "label": `Add ${labelSingular}`,
        "action": addSADD,
        show({ meta }) {
            return [ADDABLE_PARENT_TYPES.includes(meta?.ParentType), `${labelPlural} cannot be added to this, they must be linked.`]
        }
    }, {
        "label": `Link ${labelSingular}`,
        "action": linkSADD
    }];

    const rowActions = [{
        "label": `View ${labelSingular}`,
        action({ router, rowItem }) {
            router.push(`/Database/${saddParentType}/${rowItem.ID}`)
        }
    }, {
        "label": `Update ${labelSingular}`,
        "break": true,
        "action": editSADD,
        show({ meta }) {
            return [EDITABLE_PARENT_TYPES.includes(meta?.ParentType), "Can only be edited whilst in the parent"]
        }
    }, {
        "label": `Cancel ${labelSingular}`,
        "break": true,
        "action": cancelSADD,
        "class": "text-red"
    }];

    return {
        "label": labelPlural,
        "key": saddParentType,
        "location": `${saddCollection}/`,
        actions,
        rowActions,
        headers,
        warn({ items }) {
            let warningMessage = items.map(warning).filter(i => i !== false).join("");
            return [warningMessage !== "", warningMessage];
        }
    };
};

export const saddAttachable = makeSADDAttachable(STC_VARIANT);
export const militarySADDAttachable = isMilitaryEnabled() ? makeSADDAttachable(MILITARY_VARIANT) : null;

export default saddAttachable;
